module.exports = __webpack_public_path__ + "static/identyfikacja-f2ef9b1a016fcbc405b91919d42bc9d5.png";